exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cityStateCountryDetails .titles-name {\n  font-weight: bold;\n  text-transform: capitalize; }\n\n.alert-msg-type {\n  text-transform: capitalize; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/app/style/cityAndCountry/cityStateCountryDetails.scss
// module id = 374
// module chunks = 0